import React from 'react'
import NavbarSettings from './NavbarSettings';
import NavbarIcon from './NavbarIcon';
import SteamSignIn from './SteamSignIn';
import NavbarLinks from './NavbarLinks';

const NavBarNoAuthWeb = () => {
  return (
      <nav
          className="lg:block hidden fixed top-0 left-0 right-0 transition-all duration-300 z-50 bg-light dark:bg-dark border-b border-neutral-200 dark:border-neutral-700 h-[80px]"
      >
        <div className="flex justify-between h-full px-4">
          <div className="flex space-x-8">
            <NavbarIcon/>
            <NavbarLinks/>
          </div>
          <div className="flex items-center space-x-4">
            <SteamSignIn/>
            <NavbarSettings/>
          </div>
        </div>
      </nav>
  )
}
export default NavBarNoAuthWeb
